module.exports = __webpack_public_path__ + "img/lakers_silver_alpha.38758860.png";